import polylabel from 'polylabel';

export function activityLabelPosition(input, map, zoom) {
  const geometry = input?.type === 'Feature' ? input.geometry : input;
  const polygons = geometry?.type === 'MultiPolygon'
    ? geometry.coordinates
    : geometry?.type === 'Polygon' ? [geometry.coordinates] : [];
  let best = null;
  for (const rings of polygons) {
    if (!rings[0] || rings[0].length < 3) continue;
    const projected = rings.map(ring => ring.map(([lng, lat]) => {
      const point = map.project([lat, lng], zoom);
      return [point.x, point.y];
    }));
    const point = polylabel(projected, 0.25);
    if (point.distance > 0 && (!best || point.distance > best.clearance)) {
      best = {
        center: map.unproject(point, zoom),
        clearance: point.distance,
      };
    }
  }
  return best;
}

export function activityLabelScale(width, height, clearance) {
  const diagonal = Math.hypot(width, height);
  // The entire label fits inside the inscribed circle, including its corners.
  return diagonal > 0 ? Math.min(1, Math.max(0, 2 * (clearance - 2) / diagonal)) : 0;
}
